<template lang="html">
  <div>
    <v-btn class="mx-5" @click="show=true">
      Modificar
    </v-btn>
    <v-dialog v-model="show" max-width="550px">
      <v-card>
        <v-layout row class="mx-3">
          <v-flex sm3 class="mr-2">
            <v-text-field label="Texto" v-model="texto.titulo" :counter="3"
              maxlength="3"></v-text-field>
          </v-flex>
          <v-flex sm4>
            Marcador: <swatches v-model="marcador.fill" colors="text-advanced" popover-to="left"></swatches>
          </v-flex>
          <v-flex sm5>
            Circulo: <swatches v-model="circulo.fill" colors="text-advanced" popover-to="left"></swatches>
            <v-btn @click="save()">Guardar</v-btn>
          </v-flex>
        </v-layout>
        <div id="drawing"></div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import * as SVG from 'svg.js'
import Swatches from 'vue-swatches'
import "vue-swatches/dist/vue-swatches.min.css"
import Vehiculos from '../../services/vehiculos'

export default {
  props: ['vehiculoId'],
  data() {
    return {
      draw: null,
      show: false,
      color: '#1CA085',
      file: '',
      marcador: {
        fill: '#EE3840', width: 500, height: 520
      },
      circulo: {
        fill: '#FFE1D6', cx: 255, cy: 190, size: 220
      },
      texto: {
        x: 110, y: -50, size: 250, titulo: '23'
      }
    }
  },
  components: {
    Swatches
  },
  watch: {
    'marcador.fill': function(){
      this.drawSVG()
    },
    'circulo.fill': function(){
      this.drawSVG()
    },
    'texto.titulo': function(val){
      switch(val.length) {
        case 1:
          this.texto.x = 185
        break;
        case 2:
          this.texto.x = 110
        break;
        case 3:
          this.texto.x = 70
          this.texto.y = -40
          this.texto.size = 230
        break;
      }
      this.drawSVG()
    }
  },
  methods: {
    drawSVG: function(){
      if (this.draw) {
        this.draw.clear()
      } else {
        this.draw = SVG('drawing').size(this.marcador.width, this.marcador.height)
      }
      this.draw.path(`M454.848,198.848c0,159.225-179.751,306.689-179.751,306.689c-10.503,8.617-27.692,8.617-38.195,0
        	c0,0-179.751-147.464-179.751-306.689C57.153,89.027,146.18,0,256,0S454.848,89.027,454.848,198.848z`)
        .attr({ fill: this.marcador.fill })
      this.draw.circle(this.circulo.size)
        .attr({ fill: this.circulo.fill, cx: this.circulo.cx, cy: this.circulo.cy });
      this.draw.text(this.texto.titulo)
        .attr({ x: this.texto.x, y: this.texto.y })
        .size(this.texto.size)
      this.file = this.draw.svg()
    },
    save: async function() {
      let res = await Vehiculos.saveIcon(this.vehiculoId, this.file)
      if (res.ok) {
        this.$emit('update-icon')
      }
    }
  },
  mounted: function(){
    this.drawSVG()
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/shared/SvgComponent.vue